class BrixForm {
  static init(...parameters) {
    return new BrixForm(...parameters);
  }

  constructor(block) {
    if (block) {
      this.block = block;
      this.loginPageLink = block.querySelector('.login-page-link');
      if (this.loginPageLink) this.moveLink();

      this.updateTabIndex();
      this.showReCaptchaBranding();

      window.addEventListener('resize', () => {
        this.updateTabIndex();
      });
    }
  }

  moveLink() {
    const formHeading = this.block.querySelector('.gform_heading');
    if (formHeading) {
      formHeading.appendChild(this.loginPageLink);
      this.loginPageLink.classList.add('-active');
    }
    const formDescription = this.block.querySelector('.gform_description');
    if (formDescription) formDescription.classList.add('-extra-margin');
  }

  updateTabIndex() {
    const formInputs = this.block.querySelectorAll('.tab-index');

    [...formInputs].forEach((inputWrapper) => {
      const tabIndexClass = [...inputWrapper.classList].find(className => className.startsWith('index'));
      const tabIndex = tabIndexClass.split('-')[1];
      let input = inputWrapper.querySelector('input');

      if (!input) {
        input = inputWrapper.querySelector('textarea');
      }
      // eslint-disable-next-line no-param-reassign
      input.tabIndex = tabIndex;

      if (window.innerWidth < 641) {
        // eslint-disable-next-line no-param-reassign
        inputWrapper.style.gridRowStart = Number(tabIndex) + 1;
      } else {
        // eslint-disable-next-line no-param-reassign
        inputWrapper.style.gridRowStart = 'auto';
      }
    });
  }

  showReCaptchaBranding() {
    const reCaptchav3HiddenInput = this.block.querySelector('.ginput_recaptchav3');
    const reCaptchaBranding = this.block.querySelector('.grecaptcha-info');
    if (reCaptchav3HiddenInput && reCaptchaBranding) {
      reCaptchaBranding.style.display = 'block';
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-form', BrixForm.init);
}
